import React from 'react';
import styled from 'styled-components';
import { FaUser } from 'react-icons/fa';
import { colors, breakpoints } from '../../../assets/styles/GlobalStyles';

const Header = styled.div`
  background: linear-gradient(135deg, ${colors.blueDark} 0%, ${colors.blueMedium} 100%);
  padding: 2rem;
  color: white;
  text-align: center;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(45deg, transparent 0%, rgba(255,255,255,0.1) 50%, transparent 100%);
    pointer-events: none;
  }
`;

const AvatarIcon = styled.div`
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  
  svg {
    font-size: 48px;
    color: white;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 80px;
    height: 80px;
    
    svg {
      font-size: 40px;
    }
  }
`;

const ProfileName = styled.h1`
  font-size: 1.8rem;
  margin: 0;
  font-weight: 600;
  word-break: break-word;
  color: ${colors.white};
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 1.5rem;
  }
`;

const ProfileDocumento = styled.p`
  margin: 0.5rem 0 0;
  opacity: 0.9;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
`;

export const ProfileHeader = ({ nome, documento }) => (
  <Header>
    <AvatarIcon>
      <FaUser />
    </AvatarIcon>
    <ProfileName>{nome}</ProfileName>
    <ProfileDocumento>{documento}</ProfileDocumento>
  </Header>
);